import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ResponsivContent from "../../components/ResponsivContent";
import styles from "./styles.module.css";
import { AutoCompleteMultiply } from "../../components/AutoCompleteMultiply";
import SendIcon from "@mui/icons-material/Send";
import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import {
  buscarIdCadastroDetalhado,
  buscarTipoNegocioPorId,
  cadastrarVinculosTiposDeNegocio,
  termoComissionamento,
} from "../../services/api-planejamento-tributario.service";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import { LoginContext } from "../../config/Context/LoginContext";
import styled from "styled-components";
import { enviarNotificacao } from "../../utils/webSocket.util";
import InputMask from "react-input-mask";
import BlueButton from "../../components/BlueButton";
import WhiteButton from "../../components/WhiteButton";
import { CadastroContext } from "../../config/Context/CadastroContext";
import ModalArquivos from "./ModalArquivos";
import { buscarComboPorCodigo } from "../../services/auth.service";

const TextArea = styled.textarea`
  border-radius: 0.3rem;
  min-width: 30vw;
  min-height: 5rem;
  font-family: "inter";
  padding: 0.5rem;
  border-color: #c0c0c0;

  &:hover {
    border: 1px solid #000;
  }

  &:focus {
    box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);
    border: 2px solid #006bd6;
    outline: none;
  }
`;

const SelecionarTiposNegocio = () => {
  const [tiposNegocio, setTiposNegocio] = useState([]);
  const [options, setOptions] = useState([]);
  const [msg, setMsg] = useState("");
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const { dadosLogin } = useContext(LoginContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [motivMsg, setmotivMsg] = useState();
  const { dados, setDados } = useContext(CadastroContext);
  const [openModal, setOpenModal] = useState(false);
  const [isValid, setIsValid] = useState();
  const [isClient, setIsClient] = useState(false);
  const [openModalArquivos, setOpenModalArquivos] = useState(false);
  const [formModal, setFormModal] = useState({
    aceiteProposta: "Sim",
    contraproposta: "",
    observacoes: "",
  });
  const [idPlanTrib, setIdPlanTrib] = useState(null);
  // console.log("dados", dados);
  // console.log("dadosLogin", dadosLogin);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const clientParam = searchParams.get("isClient");
    clientParam === "true" && setIsClient(true);

    const fetch = async () => {
      try {
        const responseIdCadastroDetalhado = await buscarIdCadastroDetalhado(
          dadosLogin.tipoCadastroPlanTribKey
        );
        setIdPlanTrib(responseIdCadastroDetalhado.idCadastroDetalhado);
      } catch (error) {
        console.error(error);
      }
    };
    fetch();
  }, [location.search]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const tipoPlanTrib =
          dadosLogin.tipoCadastroPlanTribKey === "A" ? "associado" : "parceiro";
        const tipos = await buscarComboPorCodigo("TIPOSNEGOCIO");

        const tiposSelecionados = isClient
          ? await buscarTipoNegocioPorId(idPlanTrib, tipoPlanTrib)
          : [];
        let listaItens = tipos.detalhes.itensCombo.map((item) => {
          const splitValues = item.split("/|/");
          return {
            id: splitValues[0],
            descricao: splitValues[1],
          };
        });

        if (isClient) {
          listaItens = listaItens.filter((item) =>
            tiposSelecionados.tiposNegocio.some(
              (tipo) => tipo === parseInt(item.id)
            )
          );
        }

        setOptions(listaItens);
      } catch (error) {
        console.error(error);
        setMsg("Ops, temos um erro! Contate o suporte.");
        handleOpenSnackbarErro();
      }
    };

    idPlanTrib && fetchData();
  }, [idPlanTrib]);

  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };
  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };
  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };
  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  //#region-------- media query -----------
  const [viewport, setViewport] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setViewport({ width: window.innerWidth });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);
  //#region

  const nextStepModal = () => {
    if (!isClient) {
      let msgDeErro;
      if (tiposNegocio.length <= 0 || !motivMsg) {
        if (!motivMsg && tiposNegocio.length <= 0) {
          msgDeErro =
            "Para prosseguir, precisamos que preencha as informações solicitadas";
        } else if (!motivMsg) {
          msgDeErro =
            "É importante entendermos o que motivou você a querer fazer parte do nosso projeto";
        } else if (tiposNegocio.length <= 0) {
          msgDeErro = "Por favor, selecione ao menos 1 tipo de negócio";
        }

        setMsg(msgDeErro);
        handleOpenSnackbarErro();
      } else {
        handleModal();
      }
    } else {
      if (tiposNegocio.length > 0) {
        console.log(tiposNegocio);

        setDados({
          ...dados,
          tiposNegocio: tiposNegocio.map((item) => item.descricao),
        });
        handleModalClient(true);
      } else {
        setMsg("Por favor, selecione ao menos 1 tipo de negócio");
        handleOpenSnackbarErro();
      }
    }
  };

  const handleModalClient = (action) => {
    setOpenModalArquivos(action);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSubmit = async () => {
    try {
      let listaTiposNegocio = [];

      tiposNegocio.forEach((item) => {
        listaTiposNegocio.push({
          [dadosLogin.tipoCadastroPlanTribKey === "P"
            ? "idParceiro"
            : "idAssociado"]: idPlanTrib,
          idTipoNegocio: parseInt(item.id),
        });
      });

      const objTiposNegocio = {
        tiposNegocio: listaTiposNegocio,
        msgMotivacaoDeCadastro: motivMsg,
      };

      await cadastrarVinculosTiposDeNegocio(
        dadosLogin.tipoCadastroPlanTribKey,
        objTiposNegocio
      );

      await enviarNotificacao({
        titulo: `Novo ${
          dadosLogin.tipoCadastroPlanTribKey === "P" ? "Parceiro" : "Associado"
        } Cadastrado!`,
        texto: `Um novo ${
          dadosLogin.tipoCadastroPlanTribKey === "P" ? "parceiro" : "associado"
        } foi cadastrado e você já pode realizar a análise do mesmo.`,
        grupos: ["JURIDICO"],
        path: `/gestao/juridico?tipo=${
          dadosLogin.tipoCadastroPlanTribKey === "P"
            ? "Parceiro&id"
            : "Associado&id"
        }=${dadosLogin.idUsuario}`,
        tipo: "WARNING",
      });

      if (dados.idPai) {
        await enviarNotificacao({
          titulo: `Novo Parceiro Cadastrado!`,
          texto: `Um novo parceiro foi cadastrado e você já pode ve-lo na tela de Vínculos.`,
          usuarios: [dados.idPai],
          path: `/gestao/vinculos`,
          tipo: "SUCESS",
        });
      }
    } catch (error) {
      console.log(error);
      setMsg(error.mensagem);
      handleOpenSnackbarErro();
    }
  };

  const handleChangeAutoComplete = (value) => {
    setTiposNegocio(value);
  };

  const handleChangeTextArea = (event) => {
    const value = event.target.value;
    setmotivMsg(value);
  };

  //#region ------- modal ---------

  const submitModalForm = async (objeto) => {
    try {
      await termoComissionamento(objeto);
      setMsg("Informações salvas com sucesso!");
      handleOpenSnackbarSucesso();
    } catch (error) {
      setMsg(error.response.data.error);
      handleOpenSnackbarErro();
    }
  };

  const handleModal = () => {
    setOpenModal(true);
  };

  const handleChangeModal = (event) => {
    const { name, value } = event.target;

    setFormModal((prevState) => {
      let newState = { ...prevState };

      switch (name) {
        case "acceptRadio":
          newState.aceiteProposta = value;
          break;
        case "contraproposta":
          newState.contraproposta = value;
          !value ? setIsValid(true) : setIsValid(false);
          break;
        case "observacoes":
          newState.observacoes = value;
          break;

        default:
          break;
      }

      return newState;
    });
  };

  const handleSubmitModal = async (e) => {
    e.preventDefault();

    const obj = {
      aceiteProposta: formModal.aceiteProposta === "Sim" ? true : false,
      contraproposta: formModal.contraproposta
        ? parseFloat(formModal.contraproposta.replace("%", ""))
        : 15,
      observacoes: formModal.observacoes,
      tipoPlanTrib: dadosLogin.tipoCadastroPlanTribKey,
      idUsuario: dadosLogin.idUsuario,
    };

    if (formModal.aceiteProposta === "Não") {
      if (!formModal.contraproposta) {
        setIsValid(true);
        setMsg(
          "Nos informe uma porcentagem que melhor se enquadre no seu negócio."
        );
        handleOpenSnackbarErro();
      } else {
        await submitModalForm(obj);
      }
    } else {
      await submitModalForm(obj);
    }

    handleSubmit();

    setTimeout(() => {
      navigate(`/proposta-em-analise`);
    }, 2000);
  };

  //#endregion

  return (
    <div className={styles.main}>
      <ResponsivContent>
        <div className={styles.content}>
          <div className={styles.content__tipos}>
            <h2 className={styles.title}>
              Selecione os tipos de negócio que deseja:
            </h2>
            <div className={styles.separador}>
              {/* <AutoCompleteMultiply
                width={viewport.width < 770 ? "65vw" : "30vw"}
                valueReturn={tiposNegocio}
                codigoCombo={"TIPOSNEGOCIO"}
                labelProp={"Tipos de negócio"}
                placeHolderProp={"Tipos de negócio"}
                opcaoSelecionarTodos={true}
                onChange={(event) => {
                  handleChangeAutoComplete(event);
                }}
              /> */}
              <Autocomplete
                multiple
                disableCloseOnSelect
                options={options}
                getOptionLabel={(option) => option.descricao}
                value={tiposNegocio}
                onChange={(_, e) => handleChangeAutoComplete(e)}
                renderInput={(params) => (
                  <TextField {...params} label="Tipos de negócio" />
                )}
                fullWidth
              />
            </div>
          </div>
          {!isClient && (
            <div className={styles.content__motiv}>
              <h2 className={styles.title}>
                O que te motivou a crescer conosco?
              </h2>
              <TextArea onChange={handleChangeTextArea} value={motivMsg} />
            </div>
          )}
        </div>
        <Button
          type="submit"
          className={styles.botaoProsseguir}
          variant="contained"
          onClick={nextStepModal}
          // onClick={() => {handleSubmit(); handleModal()}}
          startIcon={<SendIcon sx={{ marginRight: "0.2rem" }} />}
          sx={{
            "&:hover": {
              transform: "scale(0.95)",
            },
          }}
        >
          Prosseguir
        </Button>
      </ResponsivContent>

      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        PaperProps={{
          style: { width: viewport.width < 770 ? "80vw" : "40vw" },
        }}
      >
        <DialogTitle>
          <h2 className={styles.title}>Comissionamento</h2>
        </DialogTitle>
        <form onSubmit={handleSubmitModal}>
          <DialogContent
            sx={{ display: "flex", gap: "1rem", flexDirection: "column" }}
          >
            <div className={styles.textContainer__modal}>
              <span>
                Como nosso{" "}
                {dadosLogin.tipoCadastroPlanTribKey === "P"
                  ? "parceiro"
                  : "associado"}
                , você receberá comissão de 15% por cada cliente que contratar
                os nossos serviços. Esta porcentagem será calculada sobre os
                valores pagos como honorários para a Taxation Mind.
              </span>
              <span>
                Ofereça serviços que reduzem tributos e potencializam lucros,
                conquistando maior fidelidade e gerando maior satisfação à sua
                base de clientes.
              </span>
            </div>

            <hr />

            <FormControl
              fullWidth
              required
              sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <FormLabel className={styles.title}>
                Você concorda com a proposta passada acima?
              </FormLabel>
              <RadioGroup
                name="acceptRadio"
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                onChange={handleChangeModal}
                value={formModal?.aceiteProposta}
              >
                <FormControlLabel
                  value="Sim"
                  control={<Radio sx={{ height: "5px" }} />}
                  label="Sim"
                />
                <FormControlLabel
                  value="Não"
                  control={<Radio sx={{ height: "5px" }} />}
                  label="Não"
                />
              </RadioGroup>
            </FormControl>

            {formModal.aceiteProposta === "Não" ? (
              <>
                <InputMask
                  mask={"99%"}
                  maskChar={null}
                  onChange={handleChangeModal}
                  value={formModal?.contraproposta}
                >
                  {() => (
                    <TextField
                      name="contraproposta"
                      placeholder="%"
                      size="small"
                      label="Contraproposta"
                      fullWidth
                      error={isValid}
                      helperText="Nos informe a porcetagem que melhor se enquadra ao seu negócio."
                    />
                  )}
                </InputMask>
                <hr />
                <h2 className={styles.title}>
                  Tem mais alguma informação que gostaria de nos passar?
                </h2>
                <TextField
                  onChange={handleChangeModal}
                  value={formModal?.observacoes}
                  name="observacoes"
                  label="Observações"
                  fullWidth
                  multiline
                  minRows={3}
                />
              </>
            ) : (
              ""
            )}
          </DialogContent>
          <DialogActions>
            <div className={styles.btnContainer__modal}>
              <WhiteButton
                textValue="Voltar"
                clickFunction={handleCloseModal}
              />
              <BlueButton textValue="Prosseguir" type="submit" />
            </div>
          </DialogActions>
        </form>
      </Dialog>

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />

      <ModalArquivos
        open={openModalArquivos}
        onClose={() => handleModalClient(false)}
        tiposNegocio={tiposNegocio}
      />
    </div>
  );
};

export default SelecionarTiposNegocio;
